export enum CepikErrorObjectEnum {
  MainOwnerLastName = 'mainOwner.lastName',
  MainOwnerName = 'mainOwner.name',
  MainOwnerPesel = 'mainOwner.peselNumber',
}
